import { LeadStatus } from '../hooks/leads/useLeads';

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  NEW: 'Ny',
  CONTACTED: 'Kontaktet',
  QUALIFIED: 'Kvalifisert',
  PROPOSAL_SENT: 'Tilbud sendt',
  NEGOTIATING: 'Forhandling',
  WON: 'Vunnet',
  LOST: 'Tapt',
  ON_HOLD: 'På vent',
};
